import { FC } from 'react';
import { useSelector } from 'react-redux';

import clsx from 'clsx';
import { DeskPlace } from 'src/components/DeskPlace/DeskPlace';
import { getAdminState } from 'src/store/admin/selectors';
import { Desk } from 'src/types';

import classes from './AdministratorDeskPlace.module.scss';

export interface AdministratorDeskPlaceProps {
  item: Desk;
}

export const AdministratorDeskPlace: FC<AdministratorDeskPlaceProps> = ({
  item,
}) => {
  const { selectedPlace, ghost } = useSelector(getAdminState);

  const active = selectedPlace?.mapPlaceId === item.mapPlaceId;

  const disabled = ghost?.mapPlaceId === item.mapPlaceId;

  return (
    <DeskPlace
      item={item}
      figureClassName={disabled ? undefined : classes.figure}
      deskClassName={clsx(classes.desk, active && classes.active)}
      chairClassName={clsx(classes.chair, active && classes.active)}
      titleClassName={clsx(classes.title, active && classes.titleActive)}
      disabled={disabled}
    />
  );
};
